var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportStateNoReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.25 4.74v.75h2.25v.922l1.5-1.5V4.74l-.75-.75-1.5-1.5-.75-.75H3v13.172l1.5-1.5V3.24h4.75zm-2.673 9.5l-1.5 1.5H13V7.817l-1.5 1.5v4.923z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.556 4.11L2.37 16.296l-1.072-1.072L13.485 3.04z",
    clipRule: "evenodd"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNyIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjI1IDQuNzR2Ljc1aDIuMjV2LjkyMmwxLjUtMS41VjQuNzRsLS43NS0uNzUtMS41LTEuNS0uNzUtLjc1SDN2MTMuMTcybDEuNS0xLjVWMy4yNGg0Ljc1em0tMi42NzMgOS41LTEuNSAxLjVIMTNWNy44MTdsLTEuNSAxLjV2NC45MjN6IiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjU1NiA0LjExIDIuMzcgMTYuMjk2bC0xLjA3Mi0xLjA3MkwxMy40ODUgMy4wNHoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==";
export { SvgReportStateNoReport as ReactComponent };